import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Sling as Hamburger } from "hamburger-react";
// import component 👇
import Drawer from "react-modern-drawer";

//import styles 👇
import "react-modern-drawer/dist/index.css";

const NavItems = [
  {
    Name: "Home",
    Route: "/",
  },
  {
    Name: "About Us",
    Route: "aboutUs",
  },
  {
    Name: "Clothing Banks",
    Route: "banks",
  },
  {
    Name: "Shop",
    Route: "shop",
  },
];

function Navigation() {
  const [isOpen, setOpen] = useState(false);
  const toggleDrawer = () => {
    setOpen((prevState) => !prevState);
  };
  return (
    <>
      <div className="w-full bg-white drop-shadow-md overflow-hidden">
        <div className="w-full md:h-[80px] h-[60px] max-w-[1300px] m-auto flex justify-between items-center md:px-6 px-4">
          {/* Logo */}
          <NavLink to={"/"}>
            <img
              src="/logo.png"
              alt="logo"
              className="w-full max-w-[90px] h-full max-h-[90px] object-contain -mt-1.5"
            />
          </NavLink>
          {/* Items */}
          <div className="md:flex hidden justify-center item-center gap-8">
            {NavItems?.map((item, index) => {
              return (
                <NavLink
                  key={index}
                  className={`font-noto font-[500] text-black text-sm border-b-2 border-transparent hover:border-secondary hover:text-secondary transition-all duration-300 `}
                  to={item.Route}
                >
                  {item.Name}
                </NavLink>
              );
            })}
          </div>
          {/* Button */}
          <div className="md:flex hidden justify-center item-center gap-4">
            <button className="w-[120px] h-[40px] rounded-lg font-noto bg-secondary text-white text-md hover:scale-105 transition-all duration-300 ">
              Donate
            </button>
            <button className="w-[120px] h-[40px] rounded-lg font-noto bg-main text-white text-md hover:scale-105 transition-all duration-300 ">
              Login
            </button>
          </div>
          <div className="md:hidden block">
            <Hamburger color="black" toggled={isOpen} toggle={setOpen} />
          </div>
        </div>
      </div>
      <Drawer open={isOpen} onClose={toggleDrawer} direction="left">
        <div className="w-full h-full flex justify-start items-center flex-col p-4">
          <div className="flex justify-center item-center flex-col gap-4 mt-4">
            {NavItems?.map((item, index) => {
              return (
                <NavLink
                onClick={toggleDrawer}
                  key={index}
                  className={`font-noto font-[500] text-black text-center text-sm border-b-2 border-transparent hover:border-secondary hover:text-secondary transition-all duration-300 `}
                  to={item.Route}
                >
                  {item.Name}
                </NavLink>
              );
            })}
          </div>
          <div className="w-full flex justify-center item-center flex-col gap-2 mt-8">
            <button className="w-full h-[40px] rounded-lg font-noto bg-secondary text-white text-md hover:scale-105 transition-all duration-300 ">
              Donate
            </button>
            <button className="w-full h-[40px] rounded-lg font-noto bg-main text-white text-md hover:scale-105 transition-all duration-300 ">
              Login
            </button>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default Navigation;
